const DELETE_SCHEDULED_DEPLOYMENT = "deployments::delete";
const DELETE_SCHEDULED_DEPLOYMENT_SUCCESS = "deployments::delete::success";
const EDIT_SCHEDULED_DEPLOYMENT = "deployments::edit";
const EDIT_SCHEDULED_DEPLOYMENT_SUCCESS = "deployments::edit::success";
const LOAD_SCHEDULED_DEPLOYMENTS = "deployments::load-scheduled";
const LOAD_SCHEDULED_DEPLOYMENTS_SUCCESS =
  "deployments::load-scheduled::success";
const SCHEDULE_DEPLOYMENT = "deployments::schedule";
const SCHEDULE_DEPLOYMENT_SUCCESS = "deployments::schedule::success";
const UNLOAD_SCHEDULED_DEPLOYMENTS = "deployments::unload-scheduled";

const loadScheduledDeploymentsAction = {
  type: LOAD_SCHEDULED_DEPLOYMENTS,
};

const unloadScheduledDeploymentsAction = {
  type: UNLOAD_SCHEDULED_DEPLOYMENTS,
};

export {
  DELETE_SCHEDULED_DEPLOYMENT,
  DELETE_SCHEDULED_DEPLOYMENT_SUCCESS,
  EDIT_SCHEDULED_DEPLOYMENT,
  EDIT_SCHEDULED_DEPLOYMENT_SUCCESS,
  LOAD_SCHEDULED_DEPLOYMENTS,
  LOAD_SCHEDULED_DEPLOYMENTS_SUCCESS,
  loadScheduledDeploymentsAction,
  SCHEDULE_DEPLOYMENT,
  SCHEDULE_DEPLOYMENT_SUCCESS,
  UNLOAD_SCHEDULED_DEPLOYMENTS,
  unloadScheduledDeploymentsAction,
};
